import { all, call, put, takeEvery } from "redux-saga/effects";

import {
  getProfileCandidateFailed,
  getProfileCandidateStart,
  getProfileCandidateSuccess,
} from "../redux/getProfileCandidate";

import { getProfileCandidateApi } from "core/http/service/internalEvents";

import { PayloadAction } from "@reduxjs/toolkit";

function* getProfileCandidateWork(action: PayloadAction<{ id: string }>) {
  const { id } = action.payload;

  try {
    const res = yield call(getProfileCandidateApi, id);

    yield put({
      type: getProfileCandidateSuccess.type,
      payload: {
        data: res,
      },
    });
  } catch (error: any) {
    yield put({
      type: getProfileCandidateFailed.type,
    });
  }
}

function* watchGetProfileCandidate() {
  yield takeEvery(getProfileCandidateStart.type, getProfileCandidateWork);
}

export default function* getProfileCandidateSaga() {
  yield all([watchGetProfileCandidate()]);
}
